import { createFileRoute } from '@tanstack/react-router';
import { influencersStaticData } from '../../influencers';

export const Route = createFileRoute('/_private-routes/influencers/search/youtube')({
  staticData: influencersStaticData
});
